import { Image } from '@gds/Icons';

import styles from './ImageCarousel.module.css';

type Props = {
  label: string;
  variant?: 'default' | 'gallery';
};

export const CarouselFallbackImage = ({ label, variant = 'default' }: Props) => (
  <div className={styles.fallbackImage} data-variant={variant}>
    <Image />
    <span className={styles.fallbackImageText}>{label}</span>
  </div>
);
